export default __webpack_public_path__ + "static/media/logomark-smooth.5aab4101.png";